export const FETCH_MESSAGES = 'MESSAGES:FETCH_MESSAGES';
export const FETCH_MESSAGES_SUCCESS = 'MESSAGES:FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_ERROR = 'MESSAGES:FETCH_MESSAGES_ERROR';

export const DELETE_NOTIFICATIONS = 'MESSAGES:DELETE_NOTIFICATIONS';
export const DELETE_NOTIFICATIONS_SUCCESS = 'MESSAGES:DELETE_NOTIFICATIONS_SUCCESS';
export const DELETE_NOTIFICATIONS_ERROR = 'MESSAGES:DELETE_NOTIFICATIONS_ERROR';

export const MARK_NOTIFICATION_AS_READ = 'MESSAGES:MARK_NOTIFICATION_AS_READ';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MESSAGES:MARK_NOTIFICATION_AS_READ_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_ERROR = 'MESSAGES:MARK_NOTIFICATION_AS_READ_ERROR';

export const GET_REQUEST_DETAILS = 'MESSAGES:GET_REQUEST_DETAILS';
export const GET_REQUEST_DETAILS_SUCCESS = 'MESSAGES:GET_REQUEST_DETAILS_SUCCESS';
export const GET_REQUEST_DETAILS_ERROR = 'MESSAGES:GET_REQUEST_DETAILS_ERROR';

export const CHANGE_ACTIVE_FILTER = 'MESSAGES:CHANGE_ACTIVE_FILTER';

export const RESET_ERROR = 'MESSAGES:RESET_ERROR';

export const UI_DATE_FORMAT = 'DD.MM.YYYY HH:mm';

export const NOTIFICATION_MESSAGE_TYPE = 'Notification';
export const PERMISSION_MESSAGE_TYPE = 'PermissionRequest';

export const NEW_NOTIFICATION_STATUS = 'New';
export const UNREAD_NOTIFICATION_STATUS = 'Unread';
export const READ_NOTIFICATION_STATUS = 'Read';

export const ATTACHMENT_URL = '/api/profile/messages/requestattachment/';

export const FILE_TYPES = ['pdf', 'xls', 'xlsx'];

export const UPDATE_PERIOD = 'MESSAGES:UPDATE_PERIOD';
export const PERIOD_MONTH = 'month';
export const PERIOD_YEAR = 'year';

export const MAX_TITLE_LENGTH = 50;
